import script from "./LiteVersion.vue?vue&type=script&setup=true&lang=js"
export * from "./LiteVersion.vue?vue&type=script&setup=true&lang=js"

import "./LiteVersion.vue?vue&type=style&index=0&id=7465ff0c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7465ff0c"]])

export default __exports__